import ReactDOM from 'react-dom';
import Icon, {IconSize} from '@/components/Icon';
import WarningSvg from '@/icons/WarningSvg';
import CloseSvg from '@/icons/CloseSvg';

import styles from './index.module.scss';

interface IProps {
    close: () => void;
}

const CompatibilityTips: React.FC<IProps> = ({close}) => {
    return (
        <div className={styles.container}>
            <div className={styles.wrap}>
                <div className={styles.main}>
                    <Icon className={styles.icon} svg={WarningSvg} size={IconSize.LG} />
                    <span className={styles.text}>
                        当前浏览器存在兼容性问题，建议切换至新版 Chrome 浏览器。
                    </span>
                    <Icon className={styles.close} svg={CloseSvg} size={IconSize.XS} onClick={close} />
                </div>
            </div>
        </div>
    );
};

let container: any = null;
function destroy() {
    if (container) {
        ReactDOM.unmountComponentAtNode(container);
        document.body.removeChild(container);
        container = null;
    }
}

function create() {
    container = container || document.createElement('div');
    document.body.appendChild(container);
    ReactDOM.render(<CompatibilityTips close={destroy} />, container);
    return destroy;
}

export const compatibilityTips = create;
